import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const ForInHouseSection = ({
  slackChannel,
  memo,
}: {
  slackChannel: string | null;
  memo: string | null;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.for_in_house")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.for_in_house.slack_channel"),
          children: (
            <Typography color="text.secondary">
              {slackChannel ?? ""}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.for_in_house.memo"),
          children: (
            <Typography color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
              {memo ?? ""}
            </Typography>
          ),
        },
      ]}
    />
  );
};

export default ForInHouseSection;
